module.exports = new __parcel__URL__("artifact_0006.0010a82e.png").toString();